import { model } from "core/util";

export const AmountLegacy = model.createModelLegacy("Amount", (json) => ({
    currencyCode: json.CurrencyCode,
    value: json.Value,
}));
